import { Affix } from 'antd';
import { COLOR_MEDIUM_GRAY } from 'constants/colors';
import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StickyContainer = styled(Affix)`
  & .ant-affix {
    padding-top: 10px;
    margin-top: -10px;
    background-color: ${COLOR_MEDIUM_GRAY}
  }
`;
